export const state = {
  isOpen: false,
  documents: [],
  loading: false,
}
